import { useAuth } from "./auth";
export const useBugReportingBody = () => {
  const {
    isReady,
    user
  } = useAuth();
  if (!isReady || !user) {
    return null;
  }
  return `




      __
      Email: ${user.profile?.email}
      User ID: ${user.id}
      `;
};